import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { DataBagService } from '../../../common/data-bag.service';

@Component({
	selector: 'app-promotions-list-filters',
	templateUrl: './promotions-list-filters.component.html',
	styleUrls: ['./promotions-list-filters.component.css'],
})
export class PromotionsListFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<any>;
	@Input() products: Array<any>;
	filters = {
		promotion_sells: [],
		promotion_offers: [],
		products: null,
		is_active: null,
	};
	protected filtersDefinition = {
		promotion_sells: {
			type: 'string',
			isArray: true,
		},
		promotion_offers: {
			type: 'string',
			isArray: true,
		},
		products: {
			type: 'string',
		},
		is_active: {
			type: 'boolean',
		},
	};

	filtersDefault() {
		this.filtersClear();
	}
}
